module.exports = __webpack_public_path__ + "img/ZRX-alt.5db0ff9a.svg";